import {
  VTextField,
  VTextarea,
  VSelect,
  VAutocomplete,
} from 'vuetify/components';

import DynamicJsonField from '@/components/form/DynamicJsonField.vue'
import FileUploader from '@/components/form/FileUploader.vue';
import LeadDetail from '@/components/modules/opportunities/Detail.vue'
import DatePickerInput from '@/components/form/DatePickerInput.vue';

import type { FormField } from '@/types/form';

export const CREATE_FORM: FormField[] = [  
  { value: 'user_id', label: 'Vendedor', component: VAutocomplete, required: true, col: 6, fetchOptions: 'searchUsers', itemText: 'name', itemValue: 'id'},
  { value: 'status', label: 'Status', component: VAutocomplete, required: true, col: 6, fetchOptions: 'searchOpportunityStatuses', itemText: 'name', itemValue: 'name'},
  { value: 'opportunity_name', label: 'Nombre', component: VTextField, required: false, col: 12 },
  { value: 'subject', 
    label: 'Cliente/Lead', 
    component: VAutocomplete, 
    required: true, 
    col: 6, 
    mdcol:12, 
    fetchOptions: 'searchClientsAndLeads', 
    itemText: (item: any) => item?.attributes?.commercial_name || item?.attributes?.name || '', 
    itemValue: (item: any) => item,
    transform: (value: any) => ({
      subject_id: value?.id ?? value,
      subject_type: value?.type === 'leads' ? 'Lead' : 'Client',
    })
  },
  { value: 'date', label: 'Fecha de Publicación', component: DatePickerInput, required: true, col: 6, range: false },
  {
    value: 'description',
    label: 'Notas',
    component: VTextarea,
  }
];

const idFieldMappings: Record<string, string> = {
  user_id: 'user',
  status: 'current_status'
};

export const EDIT_FORM: FormField[] = [...CREATE_FORM.map(field => {
  const relatedKey = idFieldMappings[field.value];
  if (relatedKey) {
    return {
      ...field,
      parse: (_: any, item: any) => item[relatedKey] || null,
      transform: (val: any) => ({
        [field.value]: val?.id ?? val
      })
    };
  }
  return field;
})];

export const HEADERS = [];

export const DEFAULT_HEADER_ORDER = [];

export const DETAIL = {
  expand_table: false,
  eye_detail: true,
  key: 'all',
  component: LeadDetail
};

export const FILTERS = [  
  { value: 'user_id', label: 'Vendedor', component: VAutocomplete, fetchOptions: 'searchUsers', itemText: 'name', 
    itemValue: (item: any) => item,
    transform: (value: any) => ({
      user_id: value?.id,
    }) 
  },
  //{ value: 'status', label: 'Status', component: VAutocomplete, fetchOptions: 'searchOpportunityStatuses', itemText: 'name', itemValue: 'name' },
  { value: 'opportunity_name', label: 'Nombre', component: VTextField },
  { value: 'subject_id', 
    label: 'Cliente/Lead', 
    component: VAutocomplete, 
    fetchOptions: 'searchClientsAndLeads', 
    itemText: (item: any) => item?.attributes?.commercial_name || item?.attributes?.name || '', 
    itemValue: (item: any) => item,
    transform: (value: any) => ({
      subject_id: value?.id ?? value,
      subject_type: value?.type === 'leads' ? 'Lead' : 'Client',
    })
  },
  { value: 'date_between', label: 'Fecha de Publicación', component: DatePickerInput, range: true },
  { value: 'created_between', label: 'Fecha de Creación', component: DatePickerInput, range: true },
  {
    value: 'description',
    label: 'Notas',
    component: VTextField,
  }
];

export const KANBAN = {
  statusField: 'status',
  confirmForm: true,
  changeFormFields: [
    {
      value: 'status_comment',
      label: 'Comentario',
      component: VTextarea,
      required: true,
      col: 12,
    },
    {
      value: 'additional_data',
      label: 'Documentos',
      isJsonArray: true,
      plainJson: false,
      component: DynamicJsonField,
      col: 12,
      children: [
        {
          value: 'label',
          label: 'Etiqueta',
          component: VTextField,
          col: 6,
        },
        {
          value: 'file',
          label: 'Archivo',
          component: FileUploader,
          module: 'activities', // importante
          col: 6,
          required: true,
          multiple: true,
        }
      ],
    },
  ],
};